import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "risa-oasis-ui_v2";
import ImageviewerModal from "../../../components/modals/imageViewerModal/imageviewerModal";
import { DraftSubmission } from "../../../data-model/draftSubmission";
import { ModalId } from "../../../enums/modalId";
import { useModalOpener } from "../../../hooks/useModalOpener";
import { closeModal } from "../../../redux/slice/modalSlice";
import { AppDispatch } from "../../../redux/store/store";
import {
  handleGoToPayerPortalInNewTab,
  handleViewDraft,
} from "../actionHandlers/draftSubmissionButtonGroupHandler";

interface DraftSubmissionButtonsGroupProps {
  draftSubmission?: DraftSubmission;
}

const DraftSubmissionButtonsGroup = (
  props: DraftSubmissionButtonsGroupProps,
) => {
  const { openedModalId } = useModalOpener();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { id: orderId } = useParams();

  return (
    <>
      <Button
        disabled={false}
        children={"Go Back To Orders"}
        onClick={() => navigate(`/worklists/singleOrder/${orderId}`)}
        buttonType={"tertiary"}
        size={"medium"}
      />
      <Button
        disabled={false}
        children={"View Draft"}
        onClick={() => handleViewDraft(dispatch)}
        buttonType={"secondary"}
        size={"medium"}
      />
      <Button
        disabled={false}
        children={"Go to Payer Portal"}
        onClick={() =>
          handleGoToPayerPortalInNewTab(props.draftSubmission?.url ?? "")
        }
        buttonType={"primary"}
        size={"medium"}
      />
      {openedModalId === ModalId.IMAGE_VIEWER_MODAL && (
        <ImageviewerModal
          fileUrls={[]}
          onClose={() => {
            dispatch(closeModal());
          }}
          filePaths={[props.draftSubmission?.file_path ?? ""]}
        />
      )}
    </>
  );
};

export default DraftSubmissionButtonsGroup;
